import React, { useState } from 'react';
import ConfirmationModal from './ConfirmationModal.tsx';

interface UpdateNotificationProps {
  onConfirm: () => void;
}

const UpdateNotification: React.FC<UpdateNotificationProps> = ({ onConfirm }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleConfirm = () => {
    setIsOpen(false);
    onConfirm();
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      message="A new version of the application is available. Would you like to update now?"
      onConfirm={handleConfirm}
      onCancel={() => setIsOpen(false)}
      confirmText="Update"
      cancelText="Later"
    />
  );
};

export default UpdateNotification;
